const NotAuthorized = () => {
  return (
    <div className="protected-wrap">
      <div className="center-area">
        <h5>You are not authorized</h5>
        <h6>Please Continue</h6>
        <a
          href="/interest-selection"
          className=" w-button"
          style={{
            backgroundColor: "#00bcd4",
          }}
        >
          Login
        </a>
      </div>
    </div>
  );
};

export default NotAuthorized;
